import { Routes } from '@angular/router';

import { GlobalSettingsComponent }  from './global-settings.component';
import { AdministratorsComponent }  from './administrators/administrators.component';
import { EditionSettingsComponent } from './edition-settings/edition-settings.component';
import { SSOSettingsComponent }     from './auth-settings/sso-settings.component';
import { ViewSSOSettingsComponent } from './auth-settings/view-sso-settings.component';
import { ProviderListComponent }     from './auth-settings/provider-list.component';
import { UserPermissionRoleListComponent } from './permission-settings/user-permission-role-list.component';
import { UserPermissionRoleComponent } from './permission-settings/user-permission-role.component';

export const globalSettingsRoutes: Routes = [
  {
    path: '',
    component: GlobalSettingsComponent,
    children: [
      {
        path: '',
        redirectTo: 'administrators',
        pathMatch: 'full'
      },
      {
        path: 'administrators',
        component: AdministratorsComponent,
        data: {
          requiredRole: 'grantEditionAdmin'
        }
      },
      {
        path: 'general-settings',
        component: EditionSettingsComponent,
        data: {
          settings: 'general',
          requiredRole: 'nomadicAdministration'
        }
      },
      {
        path: 'welcome-settings',
        component: EditionSettingsComponent,
        data: {
          settings: 'welcome',
          requiredRole: 'nomadicAdministration'
        }
      },
      {
        path: 'community-settings',
        component: EditionSettingsComponent,
        data: {
          settings: 'community',
          requiredRole: 'nomadicAdministration'
        }
      },
      {
        path: 'home-settings',
        component: EditionSettingsComponent,
        data: {
          settings: 'home',
          requiredRole: 'nomadicAdministration'
        }
      },
      {
        path: 'permissions',
        data: {
          requiredRole: 'nomadicAdministration'
        },
        children: [
          {
            path: '',
            component: UserPermissionRoleListComponent
          },
          {
            path: ':roleName',
            component: UserPermissionRoleComponent
          }
        ]
      },
      {
        path: 'view-sso-settings',
        component: ViewSSOSettingsComponent,
        data: {
          requiredRole: 'readSamlConfig'
        }
      },
      {
        path: 'sso-settings',
        data: {
          requiredRole: 'writeSamlConfig'
        },
        children: [
          {
            path: '',
            component: ProviderListComponent,
          },
          {
            path: ':id',
            children: [
              {
                path: '',
                redirectTo: 'settings',
                pathMatch: 'full'
              },
              {
                path: 'settings',
                component: SSOSettingsComponent
              },
            ]
          }
        ]
      }
    ]
  }
];



// WEBPACK FOOTER //
// /home/runner/work/nomadic-admin/nomadic-admin/nomadic-admin/src/app/global-settings/global-settings-routes.ts